
import { find, get, isArray, isEmpty } from 'lodash-es';
import { chartOptions } from '../components/ChartMessage/constants';
import {
  formatNum,
  buildExcelColumns,
  formatPercentNum,
  unitConversion,
} from '@/pages/dashboard/utils/utils';
import { formatNumberByComma } from '@/pages/datalab/utils/utils';
import pcGameDefaultIcon from '@/pages/dashboard/assets/svg/pc-game-default.svg';
import global from '@/pages/datalab/assets/svg/global.svg';
import global_wo_china from '@/pages/datalab/assets/svg/globalMainland.svg';
import { downIcon, upIcon } from '@/pages/dashboard/components/EchartsBubble/_config/constants';
type IToolTipsProps = {
  params: any[];
  metricOpt: any;
  language: string;
  legendArr: any[];
  isRankIngChartType: boolean;
  singleDimension: boolean;
  metricsType: string;
  rateSort?:boolean;
};

// 表格数据格式转换
export function formatOfType(type: string, value: string | number, digit?: number) {
  // 参数type由两部分构成: 数据类型&数据来源
  // 数据来源 chart (图) 或者 table (表格)
  const [dataType, source] = type.split('&');
  switch (dataType) {
    case 'date':
      // return moment(value).format('YYYY-MM-DD');
      return value;
    case 'number':
      // return source === 'chart'
      //   ? unitConversion(value)
      //   : formatNum(value, false, true);
      return formatNum(value, false, true);
    case 'float':
      return floatChunksFormatter(value,source);
    case 'percent':
      return formatPercentNum(value, digit);
    case 'string':
      return value;
    default:
      return value;
  }
}
export const floatChunksFormatter=(value: string | number , source: string)=>{
  // 后端返回空,直接补'-'
  const float = value && parseFloat(value as string)?.toFixed(2);
  if (float) {
    if (source === 'chart') {
      return unitConversion(float, true);
    } 
    return formatNumberByComma(float);
  } 
  return '-';
};


// 图表浮窗formatter函数
export function tooltipFormatter(props: IToolTipsProps ) {
  const {
    params,
    metricOpt,
    language,
    legendArr,
    isRankIngChartType,
    singleDimension,
    metricsType,
    // rateSort
  } = props || {};
  // debugger;
  const {
    // x_key: xKey,
    text: metric,
    // value,
    column_type: columnType,
  } = metricOpt;
  const isRankIngMetricsType = metricsType === 'rank';
  // 先排序
  params?.sort((a, b) => {
    try {
      const aValue = a.value[a.dimensionNames[a.encode.y[0]]];
      const bValue = b.value[b.dimensionNames[b.encode.y[0]]];
      // 如果指标是排名的话，排序应该从大到小
      if (isRankIngMetricsType) {
        // 从小到大排序
        return aValue - bValue;
      } 
      // 从大到小排序
      return bValue - aValue;
      
    } catch (e) {
      return 0;
    }
  });
  // 逻辑中包含 拆分对比项
  const map = new Map(); // 保存每个对比项的配置
  // 只要是长度等于1,可以认定他为单游戏，在getNewChartOptions方法处，特殊处理过
  const isSingleGameAndSingleDimension = legendArr.length === 1;
  params?.forEach((param: any) => {
    // debugger;
    const { 
      // seriesId,
      seriesName,
      // name, 
      color,
      axisValueLabel
    } = param;
    const excludeLegend = seriesName.includes('series');
    const value = param.value[param.dimensionNames[isRankIngChartType ? param.encode?.x?.[0] : param.encode?.y?.[0]]];
    const num = parseFloat(value) || 0;
    const singleDimensionTitle = seriesName?.split('_')?.[1]||'-';
    const title = excludeLegend || isSingleGameAndSingleDimension ? '' : singleDimensionTitle;
    const coverUrlIndex = legendArr.findIndex(
      (task: { selector: { title: any; }[]; }) =>
        task?.data?.[0]?.name.split(
          '_'
        )[1] === title,
    );
    const isTypeSubscript = coverUrlIndex === -1 ? 0 : coverUrlIndex;
    // 多游戏多维度
    const multipleGamesMultipleDimensions = legendArr?.[isTypeSubscript]?.data?.[0]?.coverUrl.split(
      'image://'
    )[1];

    // 单游戏多维度
    const singleGameMultiDimensional = legendArr?.[0]?.data.find(
      (task) =>
        task.name === seriesName,
    )?.coverUrl?.split(
      'image://'
    )[1];
    // top10图片
    const rankingPicturesTop10 = isRankIngChartType ? params?.[0]?.data?.img_url : '';
    // top10占比
    // const isRankIngChartRadio=param?.value?.[metricsType];
    const isRankIngChartRadio=param?.value?.[`${metricsType}_radio`];
    if (map.has(title)) {
      const { columns } = map.get(title);
      columns[0].data.push({ name: seriesName, color, singleGameMultiDimensional });
      columns[1].data.push(formatOfType(`${columnType}&chart`, value));
      columns[2].data.push(num);
      columns[2].otherValue.total += num;
    } else {
      map.set(title, {
        title,
        multipleGamesMultipleDimensions,
        singleDimension: isRankIngChartType ? false : singleDimension,
        // 只要是这个值为真，说明这个图例必定是单维度
        singleDimensionTitle:
          singleDimension && !isRankIngChartType ? singleDimensionTitle : '',
        columns: [
          {
            // 第一列 列头是日期, 列单元是维度 legends
            header: axisValueLabel,
            width: '100%',
            align: 'left',
            className: 'metric-name',
            render: (legend: any) => `<div class='circle' style='background-color: ${legend.color}'></div>
              <img 
                  class=${
  !isSingleGameAndSingleDimension || (singleDimension && !isRankIngChartType)
    ? 'hiddenCover'
    : 'lengedCover'
}
                  src=${
  (isSingleGameAndSingleDimension && !singleDimension) || isRankIngChartType
    ? handleImageCompatibility( legend.singleGameMultiDimensional || rankingPicturesTop10 ) || setUrlGlobalDefaultImg(param?.value?.game_name,[param?.value])
    : ''
}>
                  ${
  isSingleGameAndSingleDimension && !singleDimension
    ? legend.name
    : legend.name?.split('_')?.[0]
}
                  `,
            data: [
              {
                name: excludeLegend ? metric : seriesName,
                color,
                singleGameMultiDimensional,
              },
            ],
          },
          {
            // 第二列 指标, 列单元是指标数据
            header: excludeLegend ? '' : metric,
            width: '100%',
            align: 'right',
            className: 'metric-cell',
            // 如果数字不能被unitConversion换算出来，说明是不到千位，直接以原数字做处理
            data: [formatOfType(`${columnType  }&chart`, value)],
          },
          {
            // 第三列 占比, 列单元是计算的占比
            header: (!isRankIngChartType &&  (language === 'en' ? 'Share' : '占比')) || '',
            show: isRankIngChartType
              ? true
              : params?.length > 1 &&
                !isRankIngMetricsType &&
                columnType === 'number', // 一个图例不展示占比;
            width: '100%',
            align: 'right',
            className: 'metric-cell',
            data: [num],
            // 是否展示涨跌箭头
            isFloatingShow: isRankIngChartType,
            otherValue: { radio: isRankIngChartRadio },
            render(value: number, { total }: any) {
              // 排行榜场景
              if (isRankIngChartType) {
                return value ? formatPercentNum(isRankIngChartRadio, 1) : '';
              }
              return value ? formatPercentNum(value / total, 1) : '-';
            },
          },
        ],
      });
    }
  });
  return createTooltipHtml(Array.from(map.values()));
}
// 生成图表浮窗html字符串
export function createTooltipHtml(tooltips: any[]) {
  let html = '<div  class=\'chart-message-tooltip-wrap\'>';
  tooltips?.forEach((tooltip) => {
    const { columns, multipleGamesMultipleDimensions, singleDimension, singleDimensionTitle } = tooltip;
    const titleMargin = singleDimension ? 'margin-bottom: 10px' : '';
    html += `<div class='chart-message-tooltip'>
    <div class='title'  style='${titleMargin}'>
    <img class=${singleDimension ? 'cover' : 'hiddenCover'} src=${multipleGamesMultipleDimensions || pcGameDefaultIcon}>
    ${singleDimensionTitle}</div>
    <div class='table-flex'>`;
    columns.forEach((column) => {
      const {
        header,
        width,
        align,
        render,
        data,
        className = '',
        otherValue,
        show = true,
        isFloatingShow=false
      } = column;
      if (show) {
        const [ sortIcon,iconStatus] = isPositiveOrNegativeNumber(otherValue?.radio ,isFloatingShow );
        html += `<div class='table-flex-col' style='width: ${width}; text-align: ${align}'>`;
        html += `<div class='table-flex-col-header'>${header}</div>`;
        data.forEach((value: any) => {
          const str = render?.(value, otherValue) || value;
          html += `<div class='table-flex-col-cell dbl-chart-message-tips-status-${iconStatus}  ${className}'>
          ${str}
         ${isFloatingShow ? `<span  class='status-${iconStatus}'>${sortIcon|| ''}</span>` : ' ' }
          </div>`;
        });
        html += '</div>';
      }
    });
    html += '</div></div>';
  });

  html += '</div>';
  return html;
}
/**
 * 
 * @param str 正负字符串
 * @returns 返回上下箭头
 */
export function isPositiveOrNegativeNumber(str: string ,isFloatingShow: boolean ) {
  const flagMap = {
    zero: '',
    up: upIcon,
    down: downIcon,
  };
  if(isFloatingShow){
    const valueStr=/^-?\d*\.?\d+$/.test(str);
    if (valueStr) {
      if(formatPercentNum(+str, 1) === '0.0%') return  [ flagMap.zero ,'none' ]; 
      return str.indexOf('-') === -1 ? [ flagMap.up ,'up' ] :  [flagMap.down,'down' ];
    } 
    return  [flagMap.zero,'none' ];
  }
  return [];
}
// 前端下载表格数据转化
export const excelConversionFormat = <T extends { [key in string]: unknown[] }>(
  tableOption: T,
) => {
  const { columnsInfo, data } = tableOption;
  if (!isArray(data) && isEmpty(data)) return [];
  const excelColumn: string[] = buildExcelColumns(columnsInfo?.length ?? 0);
  // 表头行
  const headerRow = {};
  // 表头顺序
  const header: string[] = [];
  // 以 key 为顺序
  const keys: string[] = [];
  columnsInfo?.forEach((item) => {
    header.push(item?.name);
    keys.push(item?.origin_name);
  });
  header?.forEach((item, index) => {
    headerRow[excelColumn[index]] = item;
  });
  const excelData = [headerRow];
  data?.forEach((item) => {
    const itemData = {};
    keys?.forEach((key, index) => {
      itemData[excelColumn[index]] = formatOfType(
        `${columnsInfo?.[index]?.column_date_type  }&table`,
        item[key],
      );
    });
    excelData.push(itemData);
  });
  return [excelData];
};

// 计算高度
export const computeChartHeight = <
  A extends Array<{ [key: string]: unknown; }>,
  T extends number,
>(
  legend: A,
  // series: A,
  length: T,
  isRankIngChartType:boolean,
  isRankIngChartTypeLength:T
) => {
  // 默认行数高度*图例长度
  const defualetRow = 20;
  // 小
  const smallHeight = 330;
  // 中
  const middleHeight = 355;
  // 大
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const largeHeight = 400;
  const defaultRankingColumn = 10;
  // top10-top15需要特殊处理
  if (isRankIngChartType) {
    const lengthRankIng = isRankIngChartTypeLength > defaultRankingColumn ? 5 : length;
    return smallHeight + lengthRankIng * defualetRow;
  }
  // 没有图例
  if (isEmpty(legend?.[0]?.data) && isEmpty(legend?.[0]?.legend_column)) {
    return smallHeight + length * defualetRow;
  }
  // 正常返回高度
  return middleHeight + length * defualetRow;
};

/**
 * 根据指定的键值对数组和键名，查找符合条件的数据项。
 * @param list 键值对数组
 * @param keys 键名
 * @returns 符合条件的数据项数组
 */
export const filterDataByName = <
  O extends { [key in string]: unknown }[],
  K extends keyof O,
>(
  list: O,
  keys: K extends keyof O ? O[number]['name'] : never,
) => {
  if (!list) return [];
  const cloneDeepList = [...list];
  const dataSource = cloneDeepList.filter((task) => task.key === (keys as K));
  return dataSource;
};
/**
 * 
 * @param legend  图例数据
 * @param compareIndex   图例元素下标
 * @param userTriggeredImgType  图例需要展示图片
 * @returns 给每一个图例增加图片
 */
export const formatLegendAndPictureCoexist = <T, S>(legend: any, compareIndex: T, userTriggeredImgType: S) => {
  // eslint-disable-next-line no-param-reassign
  legend[0].formatter = (name: string) => {
    const html = `{legendGameIcon|}` + ` ${  name}`;
    return html;
  };
  // 重置图例样式
  // eslint-disable-next-line no-param-reassign
  legend[0].data[compareIndex].textStyle = {
    ...chartOptions.legend.textStyle,
    rich: {
      legendGameIcon: {
        width: 16,
        height: 16,
        backgroundColor: {
          image: userTriggeredImgType as S,
        },
      },
    },
  };
  return legend;
};

export const getUrlRegionStr=(list:any)=>{
  const firstElementUrl = get(list, '[0].url', '')?.toLowerCase();
  const includesGenreProfile =  firstElementUrl.includes("marketprofile");
  return includesGenreProfile;
};

export const setUrlGlobalDefaultImg=(type:string,dataList:any)=>{
  const cfg={
    'Global': global,
    "Global Except China": global_wo_china
  }[type];
  const isGlobalRegion=getUrlRegionStr(dataList);
  if(isGlobalRegion){
    return cfg;
  } 
  return  pcGameDefaultIcon;
};
// 获取Top10图片
export const getTop10HeatPictures = <T,>(dataList: T[], metric:string ) => {
  // await Promise.resolve(
  //   sourceData.map(async (task, index) => {
  //     const roundedImageComponent = new RoundedImageComponent(task?.img_url, 40, pcGameDefaultIcon);
  //     newObj['img' + index] = {
  //       width: 24,
  //       height: 24,
  //       backgroundColor: {
  //         image: await roundedImageComponent.drawRoundedImage()||pcGameDefaultIcon
  //       }
  //     };
  //   })
  // );
  // return newObj;
  if (!isArray(dataList) && isEmpty(dataList)) return [];
  const sourceData = [...dataList].sort((a,b)=>a?.[metric] - b?.[metric]);
  const newObj= {};
  sourceData.forEach((task, index) => {
    newObj[`img${index}`] = {
      width: 24,
      height: 24,
      backgroundColor: {
        image: task?.img_url || setUrlGlobalDefaultImg(task?.game_name,dataList)
      }
    };

  });
  return newObj;
};
/**
 * 
 * @param dataList 数据源 
 * @param key    数据源某个元素的key
 * @returns  查找每个元素断层且有数据的特殊情况处理，需要直接高亮圆点，不需要hover展示
 * TODO:直接从series中dataset处理这层关系，暂时没找到相关APi。以这种形式处理一下
 */

export const identifyGapsAndMarkPoints = (props: any ) => {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  const {dataList, key, seriesColor,legend_column,sortArray }=props||{};
  if (!isArray(dataList) && isEmpty(dataList)) return [];
  const sourceData = sortArraySequence(dataList,sortArray);
  let markPointData = [];
  // 循环当前数据源
  if (sourceData.length === 1) {
    markPointData.push({
      coord: [sourceData[0]?.date, sourceData[0]?.[key], sourceData[0][legend_column]]
    });
    return markPointData;
  };
  const resLastData=sourceData.every((res,index,arr)=> res.date=== arr?.[0]?.date);
  for (let i = 0;i < sourceData.length;i++) {
    if(resLastData){
      markPointData.push({
        coord: [sourceData[i].date, sourceData[i][key], sourceData[i][legend_column]] as [string, string, string],
      });
    }
    // 检查当前点是否有数据
    if (sourceData[i][key] !== '') {
      // 检查前一个点是否存在并且没有数据
      if (
        i !== 0 &&
        (!sourceData[i - 1] || sourceData[i - 1][key] === '' && !sourceData[i + 1]?.[key])
      ) {
        markPointData.push({
          coord: [sourceData[i].date, sourceData[i][key], sourceData[i][legend_column]] as [string, string, string],
        });
      } else if (
        i !== sourceData.length - 1 &&
        (!sourceData[i + 1] ||
          (sourceData[i + 1][key] === '' && !sourceData[i - 1]))
      ) {
        // 检查下一个点是否存在并且没有数据
        markPointData.push({
          coord: [sourceData[i].date, sourceData[i][key], sourceData[i][legend_column]] as [string, string, string],
        });
      }
    }
  }
  const isSomeCoord=checkCoordThirdItem(markPointData);
  markPointData = markPointData.map(task => {
    const item = task.coord;
    const gamePlatformKey=sourceData.find(it=>it?.date===item[0] && it?.[key] ===item[1] )?.platform;
    const getGameMetrics = get(
      find(seriesColor, (res) => {
        if(isSomeCoord&&gamePlatformKey) {
          return  res?.id.includes(gamePlatformKey);
        }
        return   (res?.id.split('_')[1] ||  res?.id) === item[2];
      }),
      'lineStyle',
      '',
    )?.color;
    return {
      ...task,
      // 指定特定坐标点的颜色
      "itemStyle": { "color": getGameMetrics }
    };
  });
  return markPointData;
};

/**  
 * 根据指定的对象属性顺序对数组对象进行排序  
 * @param {Array} array - 需要排序的数组对象  
 * @param {Array} propertyOrder - 对象属性的排序顺序  
 * @returns {Array} - 排序后的数组对象  
 */  
export function sortArraySequence(array: any[], propertyOrder: any) {  
  return array.sort((a, b) => {  
    for (const property of propertyOrder) {  
      if (a[property] < b[property]) {  
        return -1;  
      } if (a[property] > b[property]) {  
        return 1;  
      }  
    }  
    return 0;  
  });  
}

export function checkCoordThirdItem(data: any[]) {
  if (data.length === 0) {
    return true; // 空数组视为全部一致
  }

  const thirdItems = data.map(item => item.coord[2]);
  return new Set(thirdItems).size === 1;
}
/**
 * 
 * @param array lenged数组图例
 * @returns 按照业务规则进行二次拆解数据源
 * 【1】单游戏，多维度
 * 【2】单游戏，单维度
 * 【3】多游戏，多维度
 */
export function mergeDataIfAllElementsHaveOneElement(array: Array<unknown>): Array<unknown> {
  // 检查数组是否为空
  if (array.length === 0) {
    return [];
  }
  // 【3】检查数组中所有元素的 data 长度是否都为 1
  const allElementsHaveOneElement = array.every(item => item.data.length === 1);
  if (allElementsHaveOneElement) {
    // 合并所有元素的 data 为一个新的数组
    const mergedData = array.map(item => (item.data?.[0]));
    // 创建一个包含第一个元素和合并后数据的新数组
    const result = [{ ...array[0], data: mergedData, left: 'center' }];
    let isAllNameSuf = isNameSuffixEqual(result[0]?.data);
    if (result?.[0]?.data?.length === 1) {
      isAllNameSuf = false;
    }
    return [result, isAllNameSuf];
  } 
  return [array, true];
  
};

// 判断否是单游戏||多游戏
export function isNameSuffixEqual(arr: any[]) {
  // 检查数组是否为空
  if (arr.length === 0) {
    return [];
  }
  const names = arr.map(item => item?.name);
  const suffixes = names.map(name => name?.split('_')?.[1]);
  const firstSuffix = suffixes?.[0];
  return suffixes.every(suffix => suffix === firstSuffix);
}
// 重置颜色排列
export function getSameNameElements(arr) {
  const nameMap = new Map();

  arr.forEach((item) => {
    const name = item.name.split("_")[1];
    if (nameMap.has(name)) {
      nameMap.get(name).push(item);
    } else {
      nameMap.set(name, [item]);
    }
  });

  const result = Array.from(nameMap.values());
  return result;
}

// 针对刻度数字自增加1 
export function adjustNumber(num: string | number) {
  const numStr = String(num);
  const oneStr = numStr.split("")[0];
  const twoStr = numStr.split("")[1];
  let replacedNum = "";
  if (twoStr === "9") {
    replacedNum = numStr.replace(oneStr + twoStr, +(oneStr + twoStr) + 1);
  } else {
    replacedNum = numStr.replace(twoStr, +twoStr + 1);
  }
  replacedNum =
    replacedNum.slice(0, 1 + 1) + "0".repeat(replacedNum.length - 1 - 1 !==-1 ? replacedNum.length - 1 - 1 : 0);
  return replacedNum;
}

// 增加圆角
export class RoundedImageComponent {
  constructor(imageUrl, radius, defaultImageUrl) {
    this.imageUrl = imageUrl;
    this.radius = radius;
    this.defaultImageUrl = defaultImageUrl;
    this.canvas = document.createElement('canvas');
    this.context = this.canvas.getContext('2d');
    this.cache = {}; // 缓存对象，用于保存已处理的圆角图片
  }

  // 绘制圆角图像
  drawRoundedImage() {
    return new Promise((resolve) => {
      if (this.cache[this.imageUrl]) {
        // 如果在缓存中则直接使用
        resolve(this.cache[this.imageUrl]);
      } else {
        const image = new Image();
        image.crossOrigin = "anonymous"; // 防止跨域问题
        image.src = this.imageUrl;

        const defaultImage = new Image();
        defaultImage.src = this.defaultImageUrl;

        const draw = () => {
          this.canvas.width = image.width;
          this.canvas.height = image.height;
          const { context } = this;

          context.clearRect(0, 0, this.canvas.width, this.canvas.height);

          // 绘制圆角矩形路径
          context.beginPath();
          context.arc(this.radius, this.radius, this.radius, Math.PI, Math.PI * 1.5);
          context.lineTo(this.canvas.width - this.radius, 0);
          context.arc(this.canvas.width - this.radius, this.radius, this.radius, Math.PI * 1.5, Math.PI * 2);
          context.lineTo(this.canvas.width, this.canvas.height - this.radius);
          context.arc(this.canvas.width - this.radius, this.canvas.height - this.radius, this.radius, 0, Math.PI * 0.5);
          context.lineTo(this.radius, this.canvas.height);
          context.arc(this.radius, this.canvas.height - this.radius, this.radius, Math.PI * 0.5, Math.PI);
          context.closePath();

          // 裁切
          context.clip();

          // 绘制图像
          context.drawImage(image, 0, 0, this.canvas.width, this.canvas.height);

          const roundedImageUrl = this.canvas.toDataURL();
          this.cache[this.imageUrl] = roundedImageUrl; // 将处理后的圆角图片保存到缓存中

          resolve(roundedImageUrl);
        };

        image.onload = () => {
          requestAnimationFrame(draw);
        };
        image.onerror = () => {
          // 图片加载失败时，显示默认图片
          resolve(this.defaultImageUrl);
        };
      }
    });
  }
}
/**
 * 
 * @param imageUrl 图片地址
 * @returns 作用于后端返回的图片地址有些转码有些没有转码，需要兼容2种情况
 */
export const handleImageCompatibility=(imageUrl: string)=> {
  if(!imageUrl) return '';
  let decodedImageUrl = decodeURIComponent(imageUrl);
  
  if (decodedImageUrl.includes(' ')) {
    decodedImageUrl = encodeURI(decodedImageUrl);
  }
  return decodedImageUrl;
};